<template>
    <div>
        <div class="tableSelect">
            <el-form :inline="true" :model="formInline" label-position="left">
                <el-form-item label="设备MAC地址">
                    <el-autocomplete class="inline-input" v-model.trim="formInline.mac" value-key="formInline.mac"
                        :fetch-suggestions="scriptSearch" placeholder="请输入设备MAC地址" :trigger-on-focus="true" @change="handleChange" clearable
                        @select="handleSelect" style="width: 500px">
                        <template #default="{ item }">
                            <label>{{ item.mac }}</label>
                        </template>
                    </el-autocomplete>
                </el-form-item>
                <el-form-item>
                    <el-select style="width:170px; margin-right:10px;" v-model.trim="formInline.cloud" @change="handleChange" clearable>
                        <el-option clearable
                            v-for="item in env_list"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">{{ item.name }}--{{ item.id }}
                        </el-option>
                    </el-select>
                </el-form-item>
                
                <el-form-item>
                    <el-button size="small" type="primary" @click="handleAddDevice">添加单设备</el-button>
                    <el-button size="small" type="primary" @click="handleLoadTemplate">导入模版(.xls)</el-button>
                    <el-button size="small" type="primary" @click="handleDownloadTemplate">下载模版(.xls)</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="table">
            <el-table size="small" height="calc(90vh - 210px)" border row-key="id" :key="tablename" :data="tableData"
                v-loading="loadingPage" style="width: 100%"
                :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
                <el-table-column width="80" type="index" align="center" label="序号">
                    <template #default="scope">
                        <span v-text="getIndex(scope.$index)"></span>
                    </template>
                </el-table-column>
                <el-table-column min-width="50" prop="uuid" label="UUID"></el-table-column>
                <el-table-column min-width="40" prop="mac" label="MAC"></el-table-column>
                <el-table-column min-width="20" prop="log_server_port" label="端口"></el-table-column>
                <el-table-column min-width="40" prop="log_server_ip" label="服务器IP"></el-table-column>
                <el-table-column min-width="40" prop="dev_outer_ip" label="设备IP"></el-table-column>
                <el-table-column min-width="30" prop="cloud" label="云环境"></el-table-column>
                <el-table-column min-width="40" prop="create_time" label="创建时间"></el-table-column>
                <el-table-column label="操作" width="120">
                    <template slot-scope="scope">
                        <span style="color: blue;" @click="handleLogDetail(scope.row)">查看日志</span>&nbsp;&nbsp;
                        <span style="color: red;margin-left: 20px;" @click="handleLogDelete(scope.row)">删除</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <RemoteLogDevicesImport ref="importFlag" @refreshData="getData"></RemoteLogDevicesImport>
        <RemoteLogDevicesFileList ref="fileListFlag" @refreshData="getData"></RemoteLogDevicesFileList>
        <RemoteLogDevicesAdd ref="deviceAddFlag" @refreshData="getData"></RemoteLogDevicesAdd>
    </div>
</template>
<script>
import Pagination from '../components/common-new/Pagination'
import { ENV } from '../utils/options'
import RemoteLogDevicesFileList from '../components/RemoteLogDevices/RemoteLogDevicesFileList.vue'
import RemoteLogDevicesImport from '../components/RemoteLogDevices/RemoteLogDevicesImport.vue'
import RemoteLogDevicesAdd from '../components/RemoteLogDevices/RemoteLogDevicesAdd.vue'

export default {
    components: {
        Pagination,
        RemoteLogDevicesImport,
        RemoteLogDevicesFileList,
        RemoteLogDevicesAdd
    },
    name: 'RemoteLogDevices',
    data(){
        return {
            loadingPage: false,
            tablename: 'RemoteLogDevices',
            isUploading: false,

            
            formInline: {
                id: '',
                uuid: '',
                mac: '',
                log_server_port: '',
                log_server_ip: '',
                dev_outer_ip: '',
                cloud: '',
                create_time: '',

                page: 1,
                rows: 10
            },
            pageparm: {
                page: 1,
                limit: 10,
                total: 0
            },
            env_list: ENV,
            mac_list: [],
            tableData: [],
            export_data: [],
        }
    },
    methods: {
        scriptSearch(queryString, cb) {
            var results = this.mac_list.filter(item=>item.mac.toLowerCase().includes(queryString.toLowerCase()))
            cb(results);
        },
        handleSelect(item) {
            this.formInline.page=1
            this.formInline.cloud = item.id

            this.getData()
        },

        getIndex($index) {
            return (this.formInline.page - 1) * this.formInline.rows + $index + 1
        },
        callFather(parm) {
            this.formInline.page = parm.page
            this.formInline.rows = parm.limit
            this.getData()
        },
        handleAddDevice(){
            this.$refs.deviceAddFlag.deviceAddFlagFn(null, '添加设备')
        },
        handleChange(){
            this.getData()
        },
        handleLoadTemplate(){
            this.$refs.importFlag.importFlagFn('', '导入设备MAC')
        },
        downloadFileURL(vm, url){
            var iframe = vm.createElement("iframe")
            iframe.style.display ="none";
            iframe.src = url;
            vm.body.appendChild(iframe);
        },
        handleDownloadTemplate(){
            this.loadingPage=true
            this.$http['get']("remote-log-devices-template/", {}, res=>{
                this.loadingPage=false
                if(res.data.code == 200){
                    this.downloadFileURL(document, res.data.data.data)
                }else{
                    this.$message.warning(res.data.msg)
                }
            })
        },
        handleLogDetail(row){
            this.$refs.fileListFlag.fileListFlagFn(row, '文件列表展示')
        },
        handleLogDelete(row){
            let param={
                ids: row.id
            }
            this.loadingPage=true
            this.$http['get']('remote_log_devices_delete/', param, res => {
                this.loadingPage=false
                if(res.data.code == 200){
                    this.getData()
                }else{
                    this.$message.warning(res.data.msg)
                }
            })
        },
        async getData(){
            let param = {
                ...this.formInline
            }
            this.loadingPage=true
            this.$http['get']("remote-log-devices/", param, res =>{
                    this.loadingPage=false
                    if(res.code == 200 && res.status == 'success'){
                        this.tableData=res.data.results;
                        this.pageparm.total=res.data.count
                    }else{
                        this.$message.warning(res.data.msg)
                    }
                }
            )
        },

    },
    created(){
        this.getData()
    }
}

</script>
<style>
span:hover {
    cursor: pointer;
}
</style>